export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

/**
 * Regular expression for validating strings with alphanumeric characters, hyphens, and spaces.
 * @type {RegExp}
 *
 * Apart from " - ' "
 */

export const TWO_SPACE_IN_ROW_REGEX = /\s{2,}/;

export const COLOR_REGEX = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;

export const NUMBER_REGEX = /\b\d+\b/;
